const FLASH_ATTR = "data-focus-flash";
export const DEEP_LINK_FOCUS_FLASH_MS = 1600;

/** Scroll ``element`` into view and flash it once (keyframes in `app/styles/animations.css`). Returns a cancel callback. */
export function flashElement(
  element: HTMLElement,
  options: { durationMs?: number; scrollIntoView?: boolean } = {},
): () => void {
  const { durationMs = DEEP_LINK_FOCUS_FLASH_MS, scrollIntoView = true } = options;
  if (scrollIntoView) {
    element.scrollIntoView({ behavior: "instant", block: "center" });
  }
  element.setAttribute(FLASH_ATTR, "true");
  const clearTimer = window.setTimeout(() => {
    element.removeAttribute(FLASH_ATTR);
  }, durationMs);
  return () => window.clearTimeout(clearTimer);
}
